import { GroupSecurity } from '@quromedical/fhir-common';
import { Col } from 'components/base';
import { WithGroup } from 'core/auth';
import { type NavigateToTask, TaskList } from 'core/task';
import {
  CommunicationAlertList,
  RealtimeAlertsList,
  UrgentClinicalReviewList,
} from 'core/vitals';
import { Grid, Section } from 'design-system';
import { router } from 'expo-router';
import { usePractitionerTasks } from 'hooks/useTasks';
import { TaskApi } from 'integration/aggregate';
import type React from 'react';
import { useCallback } from 'react';
import { ScrollView } from 'react-native-gesture-handler';

const taskApi = new TaskApi();

export const HomeScreen: React.FC = () => {
  const navigate = useCallback<NavigateToTask>((link) => {
    router.push({ pathname: link });
  }, []);

  const usePractitionerTaskResult = usePractitionerTasks();

  return (
    <ScrollView>
      <Section hasBottomMargin hasTopMargin>
        <WithGroup groups={[GroupSecurity.PatientRead]}>
          <Grid sm={1} lg={2} xl={3} xxxxl={4}>
            <WithGroup groups={[GroupSecurity.CommunicationRead]}>
              <Col>
                <CommunicationAlertList />
              </Col>
            </WithGroup>
            <Col>
              <UrgentClinicalReviewList />
            </Col>
            <WithGroup groups={[GroupSecurity.TaskRead]}>
              <Col>
                <TaskList
                  navigate={navigate}
                  taskListSWRKey={taskApi.userTasksBaseSWRKey}
                  {...usePractitionerTaskResult}
                />
              </Col>
            </WithGroup>
            <WithGroup groups={[GroupSecurity.FeaturePreviewAI]}>
              <Col>
                <RealtimeAlertsList />
              </Col>
            </WithGroup>
          </Grid>
        </WithGroup>
      </Section>
    </ScrollView>
  );
};
